import React from 'react';
import { scrollToSection } from 'utils/scrollToSection';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer id='footer' className="footer">
            <div className="footer__container container">
                <div className="footer__content">
                    {/* Колонка 1: Экспертиза и Бренд */}
                    <div className="footer__section">
                        <h3 className="footer__title">
                            <span className="logo-gradient">Мастерская</span>
                            <span>Веб-приложений</span>
                        </h3>
                        <p className="footer__description">
                            Индивидуальная разработка MVP на React и Next.js. Фокус на качестве, скорости и решении бизнес-задач.
                        </p>
                    </div>

                    {/* Колонка 2: Навигация */}
                    <div className="footer-links">
                        <h3>Навигация</h3>
                        <button type='button' onClick={() => scrollToSection('expert-advice')}>Советы</button>
                        <button type='button' onClick={() => scrollToSection('stages')}>Процесс</button>
                        <button type='button' onClick={() => scrollToSection('projects')}>Портфолио</button>
                        <button type='button' onClick={() => scrollToSection('extras')}>Разовые задачи</button>
                        <button type='button' onClick={() => scrollToSection('contact')}>Контакты</button>
                    </div>
                </div>
                <div className="footer__bottom">
                    <p>© {currentYear} Мастерская Веб-приложений. Все права защищены.</p>
                </div>
            </div>
        </footer>
    );
}